import { render, staticRenderFns } from "./VotingRights.vue?vue&type=template&id=5fdcc272"
import script from "./VotingRights.vue?vue&type=script&lang=js"
export * from "./VotingRights.vue?vue&type=script&lang=js"
import style0 from "./VotingRights.vue?vue&type=style&index=0&id=5fdcc272&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports